import React, { Component } from "react";
import { AutoSizer, List, WindowScroller } from "react-virtualized";
import debounce from "lodash.debounce";
import PropTypes from "prop-types";
import "react-virtualized/styles.css";
import { withRouter } from "react-router";
import Thumbnail from "./Thumbnail";

const url = "https://d1wumrtbuo797i.cloudfront.net/thumb-";
class Gallery extends Component {
  resize = debounce(() => {
    if (this.list.current) {
      this.computeRows();
    }
  }, 200);

  constructor(props) {
    super(props);
    this.list = React.createRef();
  }

  state = {
    rows: [],
    heightRatio: 1,
    numRows: 0,
  };

  componentDidUpdate(prevProps) {
    if (this.props.textures !== prevProps.textures) {
      this.computeRows();
    }
  }

  computeRows = () => {
    // console.log("computing rows");
    const { textures, latestTextures } = this.props;
    if (!textures.length) return;

    const { width } = this.list.current.props;
    const defaultHeight = Math.max(width / (latestTextures ? 9 : 8), 150);
    const heightRatio = defaultHeight / 300;
    const gutter = 6;
    const rows = [];
    let startIndex = 0;
    for (let row = 0; row < textures.length; row++) {
      let numColumns = 0;
      let currentWidth = 0;
      let rowWidth = 0;
      for (let i = startIndex; i < textures.length; i++) {
        const textureWidth = textures[i].width * heightRatio;
        if (currentWidth + textureWidth > width && i > startIndex) break;
        currentWidth += textureWidth;
        numColumns += 1;
      }

      if (!currentWidth > 0) break;
      currentWidth += gutter * (numColumns - 1);
      const ratio = width / currentWidth;
      const rowHeight = parseInt(defaultHeight * ratio, 10);
      for (let i = 0; i < numColumns; i++) {
        rowWidth += parseInt(textures[startIndex + i].width * ratio * heightRatio, 10);
      }
      rowWidth += 6 * (numColumns - 1);

      rows.push({ numColumns, rowHeight, ratio, startIndex, remainder: width - rowWidth });
      startIndex += numColumns;
    }

    rows[rows.length - 1].rowHeight = defaultHeight;
    rows[rows.length - 1].ratio = 1;
    if (latestTextures) rows.length = 2;

    this.setState({ rows, heightRatio, numRows: rows.length, width });
    this.list.current.recomputeRowHeights();
  };

  toggleSelection = newId => {
    const { category, id, subcategories } = this.props.match.params;
    const selection = subcategories ? subcategories.split(",") : [];
    const index = selection.indexOf(newId.toString());
    if (index > -1) {
      selection.splice(index, 1);
    } else {
      selection.push(newId);
    }

    this.props.history.push({
      pathname: `/category/${category}/${id}/${selection.toString()}`,
    });
  };

  rowRenderer = ({ key, style, rowHeight, ratio, startIndex, numColumns, remainder }) => {
    const { textures } = this.props;
    let gutter = 6;
    const texturesArray = textures.slice(startIndex, startIndex + numColumns);

    return (
      <div key={key} style={{ ...style, display: "flex" }}>
        {texturesArray.map((texture, index) => {
          const hasChildren = texturesArray[index].children;
          let width = parseInt(texture.width * ratio * this.state.heightRatio, 10);
          let height = rowHeight - gutter;
          if (index === texturesArray.length - 1) {
            gutter = 0;
            width += remainder;
          }
          if (texture.width === 900) height = texture.height * ratio * this.state.heightRatio;

          return (
            <Thumbnail
              hasChildren={hasChildren}
              auth={this.props.auth}
              texture={texturesArray[index]}
              image_id={texturesArray[index].id}
              onClick={this.props.openModal}
              file={texturesArray[index].key}
              key={texturesArray[index].key}
              width={width}
              height={height}
              url={url + texturesArray[index].key}
              gutter={gutter}
            />
          );
        })}
      </div>
    );
  };

  renderList = (height, width, isScrolling, onChildScroll, scrollTop) => (
    <List
      style={{ outline: "none" }}
      ref={this.list}
      autoHeight
      // isScrolling={isScrolling}
      onScroll={onChildScroll}
      scrollTop={scrollTop}
      width={width}
      height={height}
      rowCount={this.state.numRows}
      rowHeight={({ index }) => this.state.rows[index].rowHeight}
      rowRenderer={({ index, key, style }) =>
        this.rowRenderer({
          ...{ index, key, style, width },
          ...this.state.rows[index],
          numrows: this.state.numRows,
        })
      }
    />
  );

  render() {
    return (
      <div>
        <WindowScroller onResize={() => this.resize()}>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <AutoSizer
              onResize={({ width }) => {
                if (this.state.width && width !== this.state.width) this.resize();
              }}
              disableHeight
              style={{ height: "0 !important" }}
            >
              {({ width }) => this.renderList(height, width, isScrolling, onChildScroll, scrollTop)}
            </AutoSizer>
          )}
        </WindowScroller>
      </div>
    );
  }
}

export default withRouter(Gallery);

Gallery.propTypes = {
  latestTextures: PropTypes.bool,
};
Gallery.defaultProps = {
  latestTextures: false,
};



// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.js